import Button from '@mui/material/Button';
import Dialog, { DialogProps } from 'shared/components/Dialog';
import Stack from '@mui/material/Stack';
import { Title } from './UnsavedChangesDialog.style';

type UnsavedChangesDialogProps = {
  onApply: () => void;
  onReject: () => void;
} & Pick<DialogProps, 'open'>;

const UnsavedChangesDialog = ({
  open,
  onApply,
  onReject,
  ...rest
}: UnsavedChangesDialogProps) => (
  <Dialog open={open} fullWidth hideCloseButton maxWidth="xs" {...rest}>
    <Stack direction="column" spacing={3}>
      <Title>Haluatko peruuttaa palvelupyynnön?</Title>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Button color="neutral" onClick={onReject}>
          En, Palaa takaisin
        </Button>
        <Button color="success" onClick={onApply}>
          Kyllä
        </Button>
      </Stack>
    </Stack>
  </Dialog>
);

export default UnsavedChangesDialog;
